import { render } from "./formFields.vue?vue&type=template&id=2c22547c"
import script from "./formFields.vue?vue&type=script&lang=js"
export * from "./formFields.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__